export enum ConfigureStatus {
  Configured = 'Configured',
  Configuring = 'Configuring',
  NotConfigured = 'NotConfigured',
}
